<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs1-15",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 15,
      // nextPage: '/questionnaire/section1/16',
      navigateType: 'CLICK_NEXT',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'longBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/Lactation.png'),
        mainTitle: 'The problems you have or are concerned about are:',
        subTitle: 'Select all that apply.',
        btn: [
          [
            {
              text: 'Postpartum pain',
            },{
              text: 'Postnatal constipation',
            }
          ],[
            {
              text: 'Pelvic floor muscle rehabilitation',
            },{
              text: 'Postpartum depression, anxiety',
            }
          ],[
            {
              text: 'Increased secretion',
            },{
              text: 'Body recovery',
            }
          ]
        ],
        hasInput: true
      }
    }
  },
  computed:{
    nextPage(){
      if(this.$store.state.qsData[this.qsNumber].answer.indexOf('Pelvic floor muscle rehabilitation') !== -1){
        return '/questionnaire/section1/16'
      }else{
        return '/questionnaire/section2'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
